import React from 'react';

import { OfferInOfferModuleFragment } from '@optioffer/graphql';

export const OfferContext = React.createContext<
  OfferInOfferModuleFragment | undefined
>(undefined);
